import { Socket, io } from 'socket.io-client'

import {
  ClientToServerEvents,
  CrashClientToServerEvents,
  CrashServerToClientEvents,
  ServerToClientEvents,
} from './events'

const URL = process.env.NEXT_PUBLIC_WS_URL || 'https://io.pigmo.com'

export const bankSocket = (
  userId: string
): Socket<ServerToClientEvents, ClientToServerEvents> => {
  return io(`${URL}/bank`, { query: { userId } })
}

export const socket: Socket<ServerToClientEvents, ClientToServerEvents> =
  io(URL)

export const crashSocket: Socket<
  CrashServerToClientEvents,
  CrashClientToServerEvents
> = io(`${URL}/crash`)
